import { ButtonType, Dropdown, EpicIcons, InputText } from "@constellation-academy/epic-ui";
import { useTranslation } from "@i18n/hooks";
import { DISCOUNT_TYPE_OPTIONS } from "./discount-action-filter.consts";
import { wrapperClass } from "./discount-action-filter.styles";
import { Button } from "../../../../components/button";
import { useDiscountActionSearchContext } from "../../discount-actions.context";
import { DiscountActionFilters } from "../../discount-actions.types";

export const DiscountActionFilter = () => {
	const { t } = useTranslation("common");

	const { filters, setFilters, clearFilters } = useDiscountActionSearchContext();

	const createOnChangeHandler = (filterKey: keyof DiscountActionFilters) => (value?: string) => {
		setFilters((prevFilters) => ({
			...prevFilters,
			[filterKey]: value,
		}));
	};

	return (
		<div className={wrapperClass}>
			<div>
				<Dropdown
					value={filters.filterByDiscountTypeKind}
					options={DISCOUNT_TYPE_OPTIONS}
					placeholder={t("discounts.discountType")}
					onChange={createOnChangeHandler("filterByDiscountTypeKind")}
				/>
			</div>
			<div>
				<InputText
					value={filters.filterByActionTitle}
					placeholder={t("discounts.actionTitle")}
					onChange={createOnChangeHandler("filterByActionTitle")}
				/>
			</div>
			<div>
				<InputText
					value={filters.filterByCode}
					placeholder={t("discounts.code")}
					onChange={createOnChangeHandler("filterByCode")}
				/>
			</div>
			<Button
				type={ButtonType.Button}
				tooltip={t("actions.clear")}
				icon={EpicIcons.TIMES}
				onClick={clearFilters}
			/>
		</div>
	);
};
